var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-layout',{attrs:{"view":"hHh LpR fFf"}},[_c('q-header',{staticClass:"text-white",attrs:{"elevated":""}},[_c('BarraSuperior')],1),_c('q-page-container',[_c('div',{staticClass:"full-width full-height",attrs:{"id":"wrapper"}},[_c('q-page',[_c('router-view')],1)],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }